'use client'

import { Shield, Lock, Search, AlertTriangle } from 'lucide-react'
import ServicePageTemplate from '@/components/ServicePageTemplate'

export default function CybersecurityPage() {
  return (
    <ServicePageTemplate
      slug="cybersecurity"
      title="Cybersecurity"
      titleHighlight="Solutions"
      description="Comprehensive security assessments, penetration testing, and protection services to safeguard your digital assets."
      accentColor="from-red-500 to-rose-600"
      stats={[
        { value: '100+', label: 'Security Audits' },
        { value: '0', label: 'Breaches Post-Audit' },
        { value: 'ISO', label: '27001 Certified' },
        { value: '24/7', label: 'SOC Monitoring' }
      ]}
      services={[
        { icon: <Search className="w-6 h-6" />, title: 'Penetration Testing', description: 'Identify vulnerabilities before attackers do.', features: ['Web App Testing', 'Network Penetration', 'Mobile App Security', 'API Security Testing'] },
        { icon: <Shield className="w-6 h-6" />, title: 'Security Audits', description: 'Comprehensive security posture assessment.', features: ['Code Review', 'Infrastructure Audit', 'Compliance Check', 'Risk Assessment'] },
        { icon: <Lock className="w-6 h-6" />, title: 'Data Protection', description: 'Protect sensitive data with encryption and access controls.', features: ['Encryption Solutions', 'DLP Implementation', 'Access Management', 'Data Classification'] },
        { icon: <AlertTriangle className="w-6 h-6" />, title: 'Incident Response', description: 'Rapid response and recovery from security incidents.', features: ['24/7 Monitoring', 'Threat Detection', 'Forensic Analysis', 'Recovery Planning'] },
      ]}
      technologies={[
        { name: 'OWASP', category: 'Framework' }, { name: 'Nessus', category: 'Scanner' },
        { name: 'Metasploit', category: 'Testing' }, { name: 'Burp Suite', category: 'Web Security' },
        { name: 'Splunk', category: 'SIEM' }, { name: 'CrowdStrike', category: 'EDR' },
        { name: 'ISO 27001', category: 'Standard' }, { name: 'GDPR', category: 'Compliance' },
      ]}
      process={[
        { step: '01', title: 'Threat Assessment', description: 'Identify assets, threats, and attack vectors.' },
        { step: '02', title: 'Vulnerability Scan', description: 'Automated and manual scanning for weaknesses.' },
        { step: '03', title: 'Penetration Test', description: 'Simulate real-world attacks to find exploits.' },
        { step: '04', title: 'Reporting', description: 'Detailed findings with severity and remediation steps.' },
        { step: '05', title: 'Remediation', description: 'Fix vulnerabilities and harden defenses.' },
        { step: '06', title: 'Ongoing Monitoring', description: 'Continuous security monitoring and alerting.' },
      ]}
    />
  )
}
